import { render, staticRenderFns } from "./dg-navigation-and-dg-below-navigation.vue?vue&type=template&id=67f0ee4c&scoped=true&"
import script from "./dg-navigation-and-dg-below-navigation.vue?vue&type=script&lang=js&"
export * from "./dg-navigation-and-dg-below-navigation.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=67f0ee4c&scoped=true&lang=css&"
import style1 from "./dg-navigation-and-dg-below-navigation.vue?vue&type=style&index=1&id=67f0ee4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f0ee4c",
  null
  
)

export default component.exports